<template>
  <div class="scene-setting">
    <my-header title="智能联动" back-path="/user"></my-header>
    <div class="container">
      <div class="content">
        <div class="item" v-for="(item,i) in initData" :key="`linkage_${i}`" @click="goUrl(item)">
          <div class="left_cot">
            <div class="images">
                <img :src="require(`@/assets/images/linkage/${item.icon}`)" alt="">
            </div>
            <span class="name">{{item.name}}</span>
          </div>
          <div class="right_cot">
            <div class="title">
              <span v-text="item.description"></span>
            </div>
            <div class="switch" @click.stop>
              <el-switch v-model="item.state" active-color="#3AD474" :disabled="!item.isShow" :active-value="1" :inactive-value="0" @change="save(item)"></el-switch>
            </div>
            <div class="jt">
              <img src="@/assets/images/home/xyy.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/HeaderTitle'
import { mapState } from 'vuex'
import basic from '@/model/zone'
import { Message } from 'element-ui'
import linkage from '@/model/linkage'

export default {
  name: 'LinkAgeSetting',
  components: {
    MyHeader
  },
  data () {
    return {
      initData: []
    }
  },
  computed: {
    ...mapState(['zone', 'linkage', 'coreIds', 'deviceMenus'])
  },
  watch: {
    linkage () {
      this.initData = JSON.parse(JSON.stringify(this.linkage.rule))
    }
  },
  async created () {
    if (!this.zone) {
      await basic.getBasicInfo()
    }
    this.initData = JSON.parse(JSON.stringify(this.linkage.rule))
  },
  methods: {
    goUrl (item) {
      if (item.isShow) {
        this.$router.push({ name: 'LinkAgeEdit', params: item })
      } else {
        Message.warning(`暂无${item.noDeviceType}设备，安装设备后可使用`)
      }
    },
    async save (item) {
      console.log(typeof (item.isShow), item.isShow)
      if (item.isSave) { linkage.updataLinkAge({ zoneId: this.zone.id, deviceId: this.coreIds, rule: this.initData, id: this.linkage.id }) }
      this.$store.commit('SET_LINKAGE', { id: this.linkage.id, rule: this.initData })
    }
  }
}
</script>

<style scoped lang="less">

.scene-setting {
  height: 100%;
  display: flex;
  flex-direction: column;
  .container {
    flex: 1;
    position: relative;
    padding: 65px 20px 0px 20px;
    overflow-y: auto;
    & .content {
      border-radius: 4px;
      //background-color: white;
      //padding: 0px 20px;
      & .item:first-child {
        border: 0px;
      }
      & .item {
        height: 55px;
        padding: 0px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background:rgba(255,255,255,1);
        border-radius:4px;
        margin-bottom: 15px;
        .left_cot {
          display: flex;
          .name {
            font-size: 17px;
            font-weight: 600;
            margin-left: 13px;
          }
        }
        .right_cot {
          display: flex;
          .jt {
            width: 9px;
            height: 16px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .switch {
            margin-right: 16px;
            margin-left: 20px;
          }
        }
        .images {
          width: 22px;
          height: 22px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        & .title {
          font-size: 16px;
          font-weight: 400;
          color: rgba(137, 137, 137, 1);
        }
      }
    }
    & .remark {
      font-size: 15px;
      font-weight: 400;
      color: rgba(198, 198, 198, 1);
      margin-top: 12px;
      display: flex;
      align-items: flex-start;
      & img {
        width: 18px;
        margin-right: 8px;
        vertical-align: middle;
      }
    }
  }
}
</style>
